import Vue from 'vue';

export const deleteBus = new Vue();
export const changeLangBus = new Vue();
export const uploadBus = new Vue();
export const categoryBus = new Vue();
export const shopBus = new Vue();
export const statusBus = new Vue();
export const offerBus = new Vue();
export const mediaBus = new Vue();
export const userBus = new Vue();
export const userGroupBus = new Vue();
export const mallBus = new Vue();
export const loginBus = new Vue();
export const slideShowBus = new Vue();
export const stationBus = new Vue();
export const parkingBus = new Vue();
export const floorBus = new Vue();
export const mallImageBus = new Vue();
export const imageBus = new Vue();
